import axiosClient from "@/service/client/AxiosClient";
import store from "@/store/index"
export default {
    isAuthenticated: async () => {
        return axiosClient.get(`/auth/isAuthenticated?t=${store.getters['auth/getT141Id']}`)
    },
    authenticate: async (payload) => {
        return axiosClient.post(`/auth/authenticate`, new URLSearchParams({
            u: payload.u,
            p: payload.p
        }))
    },
    signOut: async () => {
        return axiosClient.post(`/auth/signout`)
    },
    /**
     * Gets all parametric.
     *
     * @param payload
     * @returns {Promise<AxiosResponse<any>|*>}
     */
    getCaptions: async () => axiosClient.get(`/captions`),
    getLookups: async () => axiosClient.get(`/lookups/all`),
    getAitiaKthshs: async () => axiosClient.get(`/lookups/aitiaKthshs`),
}
